import { render, staticRenderFns } from "./BookingPassengers.vue?vue&type=template&id=0caad536&scoped=true&"
import script from "./BookingPassengers.vue?vue&type=script&lang=js&"
export * from "./BookingPassengers.vue?vue&type=script&lang=js&"
import style0 from "./BookingPassengers.vue?vue&type=style&index=0&id=0caad536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caad536",
  null
  
)

export default component.exports